module.exports = __webpack_public_path__ + "static/about-bg-bdc7fa4ab3713da15fab751125fcd6f7.jpg";